// Lets only the newest of overlapping requests apply its answer.
//
// A dialog reopened for another workspace while the first answer is still on its way would
// otherwise fill its form with the first workspace's data, and a save would then write that
// data to the second one. Call the returned function when a request starts; the check it hands
// back says, once the answer is in, whether no newer request has started since.
export const createLatestOnly = () => {
  let latest = 0;

  return () => {
    latest += 1;
    const request = latest;

    return () => request === latest;
  };
};
